function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M10.8 3.252l4.902 8.498c.414.718.168 1.635-.55 2.05-.227.13-.486.2-.75.2H4.598c-.828 0-1.5-.672-1.5-1.5 0-.263.07-.522.2-.75l4.904-8.498c.414-.717 1.331-.964 2.049-.55.228.132.418.322.55.55z",
  transform: "translate(-906 -1846) translate(340 1362) translate(0 184) translate(386 285) translate(8) translate(172 15) rotate(90 9.5 7.5)"
}))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/play-icon.e5c600e8.svg";
export { SvgComponent as ReactComponent };